export default class Crisp {
  static clear () {
    localStorage.setObject('crisp', false)
    localStorage.setObject('crisp.visible', false)
  }

  static init () {
    if (this.isInitialized()) {
      return
    }

    window.$crisp = []
    window.CRISP_WEBSITE_ID = '0c4f0c59-58af-414d-84f9-028126d5b081'
    let s = document.createElement('script')
    s.id = 'chat'
    s.src = 'https://client.crisp.chat/l.js'
    s.async = 1
    document.getElementsByTagName('head')[0].appendChild(s)
    localStorage.setObject('crisp', true)
    localStorage.setObject('crisp.visible', true)
  }

  static getCrisp () {
    return document.getElementsByClassName('crisp-client')[0]
  }

  static hide () {
    let crisp = this.getCrisp()

    if (crisp) {
      crisp.style.display = 'none'
      localStorage.setObject('crisp', true)
      localStorage.setObject('crisp.visible', false)
    }
  }

  static show () {
    this.init()

    let crisp = this.getCrisp()

    if (crisp) {
      crisp.style.display = 'inherit'
      localStorage.setObject('crisp', true)
      localStorage.setObject('crisp.visible', true)
    }
  }

  static isInitialized () {
    return localStorage.getObject('crisp', false)
  }

  static isVisible () {
    return localStorage.getObject('crisp.visible', false)
  }
}



// WEBPACK FOOTER //
// ./src/models/crisp.js